/**
 * 切记要在gis下的index.ts文件中添加示例组件
 */
import demoComponent from './demoComponent/demoComponent';

export default {
    // 添加示例组件
    demoComponent,
};

